module.exports = __webpack_public_path__ + "img/1470333788.d76b8d67.jpg";